/**
 * Created by Carsten Hibbeler on 11.02.2016.
 */
import { DataUtil } from 'plugin/liferay-widgets-react-web';

export function getFeatureId(f) {
    //id alone is only valid for one modelClassName aka. type!
    return f.properties.type + f.properties.id;
}

export function toLatLng(o) {
    if (o) {
        if (o.lat) {
            return o;
        }
        if (o.latitude) {
            return { lat: o.latitude, lng: o.longitude };
        }
        console.warn('unsupported lat lng format: ', o);
    }
}

export function getBoundsFromGeometries(geometries) {
    const bbox = new L.latLngBounds();

    geometries.forEach(geometry => {
        bbox.extend(getBoundsFromGeometry(geometry));
    });

    return bbox;
}

export function getBoundsFromGeometry(geometry) {
    const bbox = getBBoxFromGeometry(geometry);
    if (bbox) {
        const southWest = L.latLng(bbox[1], bbox[0]),
            northEast = L.latLng(bbox[3], bbox[2]);

        return L.latLngBounds(southWest, northEast);
    }
}

export function getBBoxFromGeometry(geometry) {
    let coords, bbox;
    if (!geometry.hasOwnProperty('type')) return;
    coords = _getCoordinatesDump(geometry);
    bbox = [ Number.POSITIVE_INFINITY, Number.POSITIVE_INFINITY,
        Number.NEGATIVE_INFINITY, Number.NEGATIVE_INFINITY, ];
    bbox = coords.reduce(function(prev, coord) {
        return [
            Math.min(coord[0], prev[0]),
            Math.min(coord[1], prev[1]),
            Math.max(coord[0], prev[2]),
            Math.max(coord[1], prev[3])
        ];
    }, bbox);

    if (bbox &&
        bbox[0] < Number.POSITIVE_INFINITY &&
        bbox[1] < Number.POSITIVE_INFINITY &&
        bbox[2] > Number.NEGATIVE_INFINITY &&
        bbox[3] > Number.NEGATIVE_INFINITY) {
        return bbox;
    }

    return null;
}

function _getCoordinatesDump(gj) {
    let coords;
    if (gj.type === 'Point') {
        coords = [ gj.coordinates ];
    } else if (gj.type === 'LineString' || gj.type === 'MultiPoint') {
        coords = gj.coordinates;
    } else if (gj.type === 'Polygon' || gj.type === 'MultiLineString') {
        coords = gj.coordinates.reduce(function(dump, part) {
            return dump.concat(part);
        }, []);
    } else if (gj.type === 'MultiPolygon') {
        coords = gj.coordinates.reduce(function(dump, poly) {
            return dump.concat(poly.reduce(function(points, part) {
                return points.concat(part);
            }, []));
        }, []);
    } else if (gj.type === 'Feature') {
        coords = _getCoordinatesDump(gj.geometry);
    } else if (gj.type === 'GeometryCollection') {
        coords = gj.geometries.reduce(function(dump, g) {
            return dump.concat(_getCoordinatesDump(g));
        }, []);
    } else if (gj.type === 'FeatureCollection') {
        coords = gj.features.reduce(function(dump, f) {
            return dump.concat(_getCoordinatesDump(f));
        }, []);
    }
    return coords;
}

export const transformGeometryToFeatures = (dataItem) => {
    const item = DataUtil.asItem(dataItem);
    if (item && item.geometry && item.geometry.features) {
        return item.geometry.features.map(feature => ({
            ...item,
            // className: dataItem.className,
            className: feature.properties.type,
            geometry: {
                coordinates: feature.geometry.coordinates,
                properties: feature.properties,
                type: feature.geometry.type,
            },
        }));
    }
    return [ dataItem ];
};



// WEBPACK FOOTER //
// ./js/utils/geo-utils.js